var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["a"]: () => __WEBPACK_EXTERNAL_MODULE_fs_extra_e95eee4a__["default"] });